"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useState, useEffect, ReactNode } from "react";
interface Props {
  children: ReactNode;
  rootMargin?: string;
  className?: string;
  minHeight?: number;
}
export default function LazySection(t0) {
  const $ = _c(10);
  const {
    children,
    rootMargin: t1,
    className,
    minHeight: t2
  } = t0;
  const rootMargin = t1 === undefined ? "400px" : t1;
  const minHeight = t2 === undefined ? 120 : t2;
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  let t3;
  let t4;
  if ($[0] !== rootMargin) {
    t3 = () => {
      const el = ref.current;
      if (!el) {
        return;
      }
      if (!("IntersectionObserver" in window)) {
        setVisible(true);
        return;
      }
      const observer = new IntersectionObserver(t5 => {
        const [entry] = t5;
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      }, {
        rootMargin
      });
      observer.observe(el);
      return () => observer.disconnect();
    };
    t4 = [rootMargin];
    $[0] = rootMargin;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  let t5;
  if ($[3] !== children || $[4] !== minHeight || $[5] !== visible) {
    t5 = visible ? children : <div style={{
      minHeight
    }} />;
    $[3] = children;
    $[4] = minHeight;
    $[5] = visible;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== className || $[8] !== t5) {
    t6 = <div ref={ref} className={className}>{t5}</div>;
    $[7] = className;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}